import axios from 'axios';

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '',
  timeout: 60000
});

http.interceptors.request.use(config => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers['X-Admin-Token'] = token;
  }
  return config;
});

export function login(data) {
  return http.post('/api/admin/login', data).then(res => res.data);
}

export function getAdmin(path, params) {
  return http.get(`/api/admin${path}`, { params }).then(res => res.data);
}

export function postAdmin(path, data) {
  return http.post(`/api/admin${path}`, data).then(res => res.data);
}

export function putAdmin(path, data) {
  return http.put(`/api/admin${path}`, data).then(res => res.data);
}

export function deleteAdmin(path) {
  return http.delete(`/api/admin${path}`).then(res => res.data);
}

export function uploadAdmin(path, file, fileName) {
  const data = new FormData();
  data.append('file', file);
  if (fileName) {
    data.append('fileName', fileName);
  }
  return http.post(`/api/admin${path}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => res.data);
}
